import { FormControl } from '@angular/forms';

export const DefaultTemplate = '%DATABASENAME%_%TYPE%_%yyyy%%MM%%dd%%HH%%mm%%ss%.bak';
export const DefaultTemplateMask = '%DATABASENAME%';

export interface DestinationDBStepValueForm {
  destinationFolder: FormControl<string>;
  destinationFolderLog: FormControl<string>;
  createFolder: FormControl<boolean>;
  closeConnection: FormControl<boolean>;
  backupTemplate: FormControl<string>;
  overwriteExisting: FormControl<boolean>;
  specificList: FormControl<string[]>;
}

export interface DestinationDBStepValue {
  destinationFolder: string;
  destinationFolderLog?: string;
  createFolder?: boolean;
  closeConnection?: boolean;
  backupTemplate: string;
  overwriteExisting?: boolean;
  specificList?: string[];
  valid: boolean;
}
